/* import __COLOCATED_TEMPLATE__ from './header.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();